import { ICampaign } from '@/types';
import { getUrl } from '@/utils/api';

function useCampaign(id: string, options?: any) {
  const query = getUrl(`v1/campaigns/${id}`, options);
  return {
    ...query,
    data: query.data as ICampaign,
  };
}

export default useCampaign;
